import React, {Component} from "react"
import {InjectedIntl} from "react-intl"
import moment from "moment"

import authentication from "@irati/auth"
import Bar from "@irati/ui/src/Bar"
import {H2} from "@irati/ui/src//Typography/Heading"
import {SmallCaption} from "@irati/ui/src/Labels"
import Card from "@irati/ui/src/Layout/Card"
import InfoTooltip from "@irati/ui/src/FormItem/utils/InfoTooltip"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {getStats} from "@irati/medical/services/medical"
import Loading from "@irati/ui/src/Loading"
import medicalTracking from "@irati-tracking/medical"
import DownloadReport from "@irati-web/medical/src/components/DownloadReport/DownloadReport"

import NumberAndText from "../../components/NumberAndText"
import SignedUpAndRemaining from "../../components/SignedUpAndRemaining"
import {Grid} from "../../components/shared"
import {Tracker, CenteredButton, EmployeeTotalWrapper, EmployeeTotal, InlinePara, TooltipWrapper, HeadingFlex} from "./styled"

interface State {
  totalLicenses: number,
  numberActivated: number,
  load: Promise<void>
}

class Reports extends Component<InjectedIntl, State> {
  constructor(props: InjectedIntl) {
    super(props)
    medicalTracking.viewReports()
    this.state = {
      load: getStats().then(({totalLicenses, numberActivated}) => this.setState({totalLicenses, numberActivated})),
      totalLicenses: 0,
      numberActivated: 0
    }
  }

  getDate = () => {
    if (
      moment().isBefore(
        moment()
          .hour(2)
          .minute(0)
          .second(0)
      )
    ) {
      return moment()
        .subtract(1, "days")
        .format("DD/MM/YYYY")
    }
    return moment().format("DD/MM/YYYY")
  }

  render() {
    const {totalLicenses, numberActivated, load} = this.state
    const {formatMessage} = this.props

    return (
      <Grid>
        <Loading load={load}>
          <HeadingFlex>
            <H2 base>
              <FormattedMessage id="medical.reports.title" />
            </H2>
            <SmallCaption>
              <FormattedMessage id="medical.reports.lastUpdated" values={{date: this.getDate()}} />
            </SmallCaption>
          </HeadingFlex>
          <InlinePara large>
            <FormattedMessage id="medical.reports.para" />
          </InlinePara>
          <TooltipWrapper>
            <InfoTooltip tooltip={formatMessage({id: "medical.reports.tooltip"})} position="bottom" customIcon />
          </TooltipWrapper>
          <Tracker>
            <EmployeeTotalWrapper>
              <EmployeeTotal>
                <NumberAndText number={totalLicenses} text="medical.reports.employees.total" />
              </EmployeeTotal>
            </EmployeeTotalWrapper>
            <Card>
              <Bar delay score={numberActivated} maxScore={totalLicenses} />
              <SignedUpAndRemaining numberActivated={numberActivated} totalLicenses={totalLicenses} />
            </Card>
          </Tracker>
          <DownloadReport
            Comp={CenteredButton}
            large
            centre
            trackingEventName="medical_download_report"
            tenant={authentication.userTenant()}>
            <FormattedMessage id="medical.reports.employees.button" />
          </DownloadReport>
        </Loading>
      </Grid>
    )
  }
}

export default injectIntl(Reports)
